import { Grid } from "@material-ui/core"
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { SelectBox, Text } from "sunrise-ui";
import { getAllMasterType } from "../../redux/reducers";
import { getAllAssignedMachineData, getAllMachineData, getMachineData } from "../../redux/reducers/machineReducers";
import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { getDieselOverview, getMachineServiceFeedData } from "../../redux/reducers/reportReducer";
import { AppDispatch } from "../../redux/store";
import Loader from "../../utilities/Loader";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import { HeadLines } from "../Dashboard/Dashboard";
import MachineStatusFeed from "./MachineStatusFeed";
import MachineDeploymentReport from "./PandMReport/MachineDeploymentReport";
import MachineOverview from "./PandMReport/MachineOverview";
import MachinePartReport from "./PandMReport/MachinePartReport";
import "./Reports.scss";
import ReportsFeedTable from "./ReportsFeedTable";


const MachineTypeHeadlines = (props: any) => {
    const { machineTypes, machineList } = props;

    const getMachineCount = (type: string) => {
        return machineList.filter((machine: any) => machine.type.toLowerCase() === type.toLowerCase()).length
    }

    const generateMachineTypeHeadlines = () => {
        return machineTypes?.map((type: any, id: number) => (
            <div className="white-space-nw" key={`type_headline_${id}`}>
                <HeadLines
                    label={type}
                    icon={"rentalMachine"}
                    value={getMachineCount(type)}
                    fontSize={18}
                />
            </div>
        ))
    }

    return (
        <>
            {machineTypes && machineList &&
                generateMachineTypeHeadlines()
            }
        </>
    );
}

const PandMReport = () => {

    const [projectList, setProjectList] = useState([]);
    const [projectName, setProjectName] = useState("");
    const [projectId, setProjectId] = useState("");

    const [machineList, setMachineList] = useState([]);
    const [machineName, setMachineName] = useState("");
    const [machineId, setMachineId] = useState("");

    const [finalArr, setFinalArr] = useState<any>([]);
    const [machineTypeList, setMachineTypeList] = useState([]);
    const masterArray = ["Machine", "machineStatus"];

    const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
    const allMachineData = useSelector((state: any) => state.MACHINE.allMachineData);
    const dieselOverview = useSelector((state: any) => state.REPORT.dieselOverview);
    const allAssignedMachineData = useSelector((state: any) => state.MACHINE.allAssignedMachineData);
    const machineData = useSelector((state: any) => state.MACHINE.viewMachineData);
    const machineServiceFeedData = useSelector((state: any) => state.REPORT.machineServiceFeedData);
    const allMasterTypes = useSelector((state: any) => state.UI.allMasterType);
    const dispatch = useDispatch<AppDispatch>();

    const [machineOverviewLoader, setMachineOverviewLoader] = useState(false);

    useEffect(() => {
        if (masterArray.length > 0) {
            masterArray.forEach((val: any) => {
                dispatch(
                    getAllMasterType({
                        endPoint: `master-data/get-all-master-types?type=${val}`,
                    })
                );
            });
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (machineData)
            setMachineOverviewLoader(true);
    }, [machineData])

    useEffect(() => {
        dispatch(
            getAllProjectData({
                endPoint: `project/get-all-projects`,
            })
        );

        dispatch(
            getDieselOverview({
                endPoint: `reports/get-diesel-overview`,
            })
        );

        dispatch(
            getAllMachineData({
                endPoint: `machine/list?status=&project=`,
            })
        );
        dispatch(
            getMachineServiceFeedData({
                endPoint: `reports/get-machine-service-feed`,
            })
        );
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (allMasterTypes !== undefined) {
            setFinalArr((oldArr: any) => [...oldArr, allMasterTypes.data]);
        }
    }, [allMasterTypes]);

    //checking for duplicate array in some cases
    useEffect(() => {
        const typeArr: any = [];

        finalArr.forEach((val: any) => {
            if (val?.length > 0) {
                if (val[0].type === "Machine" && typeArr.length < 1) {
                    val.forEach((element: any) => {
                        typeArr.push(element.title);
                    });
                }
            }
        });
        console.log(finalArr);
        setMachineTypeList(typeArr);

        // eslint-disable-next-line
    }, [finalArr]);

    const populateListData = (listData: any, identifier: string, storeFunc: any) => {
        let arr2: any = [];
        listData?.forEach((val: any) => {
            arr2.push(val[identifier]);
        });
        storeFunc(arr2);
    }

    //set id method
    const setObjectId = (
        list: Array<any>,
        index: any,
        setMethod: Function,
        key: string
    ) => {
        setMethod(list[index][key]);
    };

    useEffect(() => {
        populateListData(allProject, 'projectName', setProjectList);
    }, [allProject]);

    useEffect(() => {
        allMachineData?.length ? populateListData(allMachineData, 'machineDetail', setMachineList) : setMachineList([]);
    }, [allMachineData]);

    useEffect(() => {
        if (projectId)
            dispatch(
                getAllAssignedMachineData({
                    endPoint: `machine/list?status=&project=${projectId}`,
                })
            )
        // eslint-disable-next-line
    }, [projectId]);

    useEffect(() => {
        if (machineId)
            dispatch(
                getMachineData({
                    endPoint: `reports/get-machine-overview?machine=${machineId}`,
                })
            )
        // eslint-disable-next-line
    }, [machineId]);

    const changeResetValue = () => { };



    return (
        <Grid spacing={2}>
            <Grid item xs={12}>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt1"
                >
                    <span className="fw500">Machine Overview</span>
                </Text>
            </Grid>
            <Grid className="flex_start mt1 headline_slider">
                <div className="white-space-nw">
                    <HeadLines
                        label="Machines at Site"
                        icon={"machineUsed"}
                        value={allMachineData?.length}
                        fontSize={18}
                    />
                </div>
                {machineTypeList && <MachineTypeHeadlines machineTypes={machineTypeList} machineList={allMachineData} />}
            </Grid>

            <Grid item xs={12}>
                <Text
                    type="normal"
                    fonts="normal"
                    fontSize={18}
                    className="mb0 mt1"
                >
                    <span className="fw500">Diesel Overview</span>
                </Text>
            </Grid>

            <div className="headline_slider">
                <div className="white-space-nw">
                    <HeadLines
                        label="Total Diesel issued for all machines till date"
                        icon={"fuelCan"}
                        value={dieselOverview ? dieselOverview?.totalDieselIssued : 0}
                        fontSize={18}
                    />
                </div>
                <div className="white-space-nw">
                    <HeadLines
                        label="Average Diesel consumption per day"
                        icon={"fuelCanDashed"}
                        value={`${dieselOverview ? dieselOverview?.avgDieselConsumption : 0} Liters`}
                        fontSize={18}
                    />
                </div>
                <div className="white-space-nw">
                    <HeadLines
                        label="Average Diesel consumption of Machine per hour"
                        icon={"fuelCanDashed"}
                        value={dieselOverview ? dieselOverview?.avgDieselConsumptionPerHour : 0}
                        fontSize={18}
                    />
                </div>
            </div>


            <Grid container className="no_flex_wrap" >
                <Grid container xs={5} className="bg--white box--shadow p1 mt mr-1">
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt0"
                        >
                            <span className="fw500">Overall Machine Overview</span>
                        </Text>
                    </Grid>
                    <Grid item xs={8}>
                        <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt1">
                            <span className="fw500">Select Machine</span>
                        </Text>
                        <SelectBox
                            data={machineList}
                            placeHolder="Select Machine"
                            defaultVal={machineName}
                            resetVal={machineName === "" ? true : false}
                            changeReset={changeResetValue}
                            onChange={(e) => {
                                let target = { ...e };
                                setMachineName(target.target.value);
                                const index = machineList
                                    ?.map((item: any) => item)
                                    .indexOf(target.target.value);
                                setObjectId(allMachineData, index, setMachineId, "id");
                                setMachineOverviewLoader(false);
                            }}
                            borderColor={"primary"}
                        />
                    </Grid>
                    <Grid style={{ height: '18rem' }} xs={12}>
                        {machineId ? machineOverviewLoader ? <MachineOverview machineData={machineData} /> : <Loader
                            color="#5f67e0"
                            loading={machineOverviewLoader}
                            size={20}
                            height="10vh"
                            style={{ width: "4rem" }}
                        /> : <SelectOptionMsg text={`Select machine to view Machine information`} />}
                    </Grid>



                </Grid>
                <Grid container xs={7} className="d-flex bg--white box--shadow p1 mt">
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt0"
                        >
                            <span className="fw500">Machine Active, Idle and Under Maintenance Overview</span>
                        </Text>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid className="standared_width mb">
                            <Text type="normal" fonts="normal" fontSize={18} className="mb0 mt1">
                                <span className="fw500">Select Project</span>
                            </Text>
                            <SelectBox
                                data={projectList}
                                placeHolder="Select Project"
                                defaultVal={projectName}
                                resetVal={projectName === "" ? true : false}
                                changeReset={changeResetValue}
                                onChange={(e) => {
                                    let target = { ...e };
                                    setProjectName(target.target.value);
                                    const index = projectList
                                        ?.map((item: any) => item)
                                        .indexOf(target.target.value);
                                    setObjectId(allProject, index, setProjectId, "_id");
                                }}
                                borderColor={"primary"}
                            />
                        </Grid>
                    </Grid>

                    {projectName?(<Grid item xs={12}>
                        <MachineStatusFeed title={'Machine Status Details'} listData={projectId ? allAssignedMachineData : []} />
                    </Grid>):(<SelectOptionMsg text={`Select Project to view Machine information`} />)}

                </Grid>
            </Grid>

            {machineServiceFeedData && <ReportsFeedTable listData={machineServiceFeedData} title="Service and Maintenance Details" />}

            <MachineDeploymentReport machineTypeList={machineTypeList} projectList={projectList} allProjects={allProject} />

            <MachinePartReport machineTypeList={machineTypeList} projectList={projectList} allProjects={allProject} />

        </Grid >
    )
}

export default PandMReport;